<template>
  <v-app class="primary white--text">
    <!-- Google Tag Manager (noscript) -->
    <noscript>
      <iframe height="0" src="https://www.googletagmanager.com/ns.html?id=GTM-PVH58B2"
              style="display:none;visibility:hidden"
              width="0"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
    <v-toolbar flat class="py-4 primary white--text elevation-0">
      <v-container fluid fill-height class="heading">
        <v-layout row wrap justify-center align-center>
          <v-flex shrink>
            <a href="/">
              <img alt="Virgin Money Logo" class="main-logo" src="/img/logo.png" width="200">
            </a>
          </v-flex>
          <v-spacer/>
          <!-- <v-flex shrink>
            <div class="call-us">
              <a href="tel:+27861506070" class="d-flex align-center justify-center">
                <span class="hidden-md-and-down mr-2">0861 50 60 70</span>
                <img src="/img/call-back.png" alt="Telephone icon">
              </a>
            </div>
          </v-flex> -->
        </v-layout>
      </v-container>
    </v-toolbar>
    <v-content class="pb-5">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'App',
    data: () => ({
      firstName: store.state.firstName
    })
  }
</script>

<style lang="stylus">
  //button: '#3ed29f'

  @import "~vuetify/src/stylus/app.styl"


  @keyframes shrinkButton {
    from {
      width: 9.5rem
    }
    to {
      width: 3.5rem
    }
  }

  .button-loader
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    border-radius: 5rem
    border: 0.5rem white solid
    height: 3.5rem
    width: 9.5rem
    animation shrinkButton 1
    background: #FFF
    animation-fill-mode: forwards
    animation-duration: 0.3s

  .v-btn
    color: #3ed29f !important
    background #ffffff !important
    border-radius: 5rem
    height: 4rem
    padding-left: 3rem
    padding-right: 3rem
    font-weight: bold !important
    text-transform: unset

  .primary--text
    color: #FFF !important

  .application
    font-family: 'Montserrat', 'Arial', sans-serif !important

    .container:not(.fluid)
      max-width: 1185px

  .application.theme--dark a
    color: #fff
    text-decoration: none

  .application .v-menu__content .v-select-list .v-list .v-list__tile .v-list__tile__content .v-list__tile__title
    color: #f11706

  .theme--light.v-list .v-list__tile--link:hover, .theme--light.v-list .v-list__tile--highlighted, .theme--light.v-list .v-list__group__header:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  h1, h2
    font-size: 2.5em;
    font-weight: 400

  .text-list
    margin-top: 12px
    padding-left: 20px

  form
    .v-input--required
      label
        &:after
          margin-left: 3px

    .v-input__details
      min-height: initial

      .v-input__messages v-input__error
        min-height: 26px

    .v-input
      label,
      input
        font-size: 14px
        color: #fff !important

      .v-select__slot
        display: grid
        grid-template-rows: auto auto
        grid-template-columns: auto 2rem

        input
          height: 0

        .v-input__append-inner
          .v-icon
            color: #FFF

        .v-select__selections
          grid-row: 2
          color: #FFF

        .v-label
          white-space: normal
          word-break: normal
          position: unset !important
          margin-right: 2rem
          margin-bottom: -1.5rem
          top: unset
          bottom: 0
          height: auto
          font-size: 12px

          &.v-label--active
            transform: translateY(-18px)

      .v-input__slot::before
        border-color: #FFF !important

      &.v-input--selection-controls
        &.v-input--checkbox
          margin-top: 0

        label, .v-label
          font-size: 12px

      .v-messages
        min-height: unset

        &:before,
        &:after
          background-color: #fff !important

      &.error--text
        .v-messages
          padding-left: 8px
          background-color: rgba(255, 255, 255, 0.2)

    .slider-wrapper
      padding-top: 18px
      position: relative
      top: 0
      left: 0

      .v-input--slider
        position: relative
        top: 0
        left: 0

        label
          position: absolute
          top: 0
          left: 0
          font-size: 14px

        .slider
          cursor: pointer
          position: relative
          z-index: 2
          margin-left: -16px
          margin-right: -16px
          background: transparent

          .slider__track__container
            .slider__track
              height: 1px

      .v-input--slider + .v-input
        width: 100%
        max-width: 90px
        position: absolute
        top: 3px
        right: -15px

        input
          text-align: right

        .v-input__details
          display: none

  .btn.submit-button
    background: #FFF !important
    color: #21cc94 !important
    border-radius: 25px
    height: 54px
    border: none
    text-transform: none

    &:hover
      background: #21cc94 !important
      color: #FFF !important

    .btn__content
      padding: 18px 35px

  hr
    width: 100%
    height: 1px
    border: none
    background-color: rgba(255, 255, 255, 0.4)

  .avatar
    margin: 0 auto
    box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.1)
    border-radius: 50%
    display: inline-flex

  .typed-cursor
    display: none

  .message-wrapper
    background: #FFF
    border-radius: 10px
    padding: 15px
    position: relative
    top: 0
    left: 0
    box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.1)

    .message
      color: #77787b

      &.typing
        width: 100%

      &:last-child
        margin-bottom: 0

    &:before
      content: ''
      position: absolute
      left: 50%
      top: -20px
      transform: translateX(-50%)
      width: 25px
      height: 10px
      border-top: 15px solid transparent
      border-right: 15px solid transparent
      border-bottom: 8px solid #FFF
      border-left: 15px solid transparent

  .radio-group.button-radio-group
    .v-input
      label
        // .btn
        align-items: center
        display: inline-flex
        height: 36px
        flex: 0 1 auto
        font-size: 14px
        font-weight: 500
        justify-content: center
        position: relative
        // .btn--round
        border-radius: 28px
        // custom styles
        left: 0
        border: 1px solid currentColor
        width: 100%

      .v-input__input
        display: none

      &.v-input--active
        label
          background-color: #20cb91
          border-color: #20cb91
          font-weight: bold

      &.v-input--disabled
        cursor: not-allowed

        label
          background-color: #d2d3d5
          color: #97989c !important
          border-color: #d2d3d5

      &.v-input--active.v-input--disabled
        label
          background-color: #20cb91
          border-color: #20cb91
          color: #fff !important

      &.mx-auto
        label
          margin: 0 auto

  .dialog__content
    &.dialog__content__active
      background-color: rgba(241, 23, 6, 0.5)

  @media screen and (max-width: 600px)
    h1, h2
      font-size: 1.75em

    nav.toolbar
      padding-top: 12px !important
      padding-bottom: 12px !important

      .toolbar__content
        height: initial !important

        .container
          padding: 0px 18px 0 6px

          .layout
            width: 100%

            .main-logo
              width: 140px

        .heading
          flex-direction: column

          .call-us
            img
              width: 40px
              height: 40px

    .container.grid-list-md
      padding-left: 18px
      padding-right: 18px

    .radio-group.button-radio-group
      .v-input__input
        flex-direction: column

      .v-input
        justify-content: center

        label
          margin-bottom: 12px

    form
      .v-input
        label,
        input
          font-size: 16px

      .slider-wrapper
        .v-input--slider + .v-input
          right: 0
</style>
